import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { MessageSquare, Search, HelpCircle } from 'lucide-react';
import QuotesModule from './QuotesModule';
import SpecialRequestsModule from './SpecialRequestsModule';
import ContactRequestsModule from './ContactRequestsModule';

const ContactManagement = () => {
  return (
    <div className="space-y-6 pr-0 sm:pr-6" dir="rtl">
      <div className="space-y-2">
        <h2 className="text-2xl sm:text-3xl font-bold text-right">ניהול פניות ויצירת קשר</h2>
        <p className="text-sm sm:text-base text-muted-foreground text-right">
          ניהול כל הפניות מהאתר - הצעות מחיר, חיפוש מוצרים ופניות קשר
        </p>
      </div>

      <Tabs defaultValue="contact" className="w-full" dir="rtl">
        <TabsList className="grid w-full grid-cols-1 sm:grid-cols-3 mb-6 h-auto">
          <TabsTrigger value="contact" className="flex items-center gap-2 justify-center">
            <HelpCircle className="h-4 w-4" />
            <span className="text-xs sm:text-sm">יצירת קשר</span>
          </TabsTrigger>
          <TabsTrigger value="special" className="flex items-center gap-2 justify-center">
            <Search className="h-4 w-4" />
            <span className="text-xs sm:text-sm">מצא לי מוצר</span>
          </TabsTrigger>
          <TabsTrigger value="quotes" className="flex items-center gap-2 justify-center">
            <MessageSquare className="h-4 w-4" />
            <span className="text-xs sm:text-sm">הצעת מחיר למוצר בודד</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="contact" className="mt-0">
          <ContactRequestsModule />
        </TabsContent>

        <TabsContent value="special" className="mt-0">
          <SpecialRequestsModule />
        </TabsContent>

        <TabsContent value="quotes" className="mt-0">
          <QuotesModule />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ContactManagement;
